import BaseLayout from '@/components/layouts/BaseLayout';
import LayoutBlank from '@/components/layouts/LayoutBlank';
import Main from '../pages/Area/Main';

export default [{
    path: '/area_management',
    name: 'area_management',
    title: 'area_route',
    navbar: true,
    icon: 'fas fa-circle-notch',
    meta: { perm: 'Navbar.Area' },
    component: BaseLayout,
    children: [{
            path: '/area_management',
            icon: 'ion ion-md-settings',
            title: 'area_management',
            component: Main,
            name: 'area_management',
            hide: true,
            meta: { perm: 'Navbar.Area' },
        },
        {
            path: 'area-route-group',
            name: 'area_route_group',
            icon: 'fas fa-vector-square',
            title: 'area_route_group',
            meta: { perm: 'Pages.PolygonGroup' },
            component: () =>
                import ('@/pages/Area/PolygonGroup/PolygonGroupList'),
        },
        {
            hide: true,
            path: 'area-route-group-edit',
            name: 'area_route_group_edit',
            icon: 'fas fa-vector-square',
            title: 'area_route_group_edit',
            meta: { perm: 'Pages.PolygonGroupEdit' },
            component: () =>
                import ('@/pages/Area/PolygonGroup/PolygonGroupEdit'),
        },
        {
            path: 'area_create',
            name: 'area_create',
            icon: 'fas fa-vector-square',
            title: 'area_route_management',
            meta: { perm: 'Pages.AreaCreate' },
            component: () =>
                import ('@/pages/Area/AreaCreate'),
        },
        {
            path: 'create_route_via_vehicle',
            name: 'create_route_via_vehicle',
            icon: 'ion ion-ios-car',
            title: 'create_route_via_vehicle',
            meta: { perm: 'Pages.CreateRouteViaVehicle' },
            component: () =>
                import ('@/pages/Area/CreateRouteviaVehicle'),
        },
        {
            path: 'suspicious',
            name: 'suspicious',
            icon: 'fas fa-user-secret',
            title: 'suspicious_area_management',
            meta: { perm: 'Pages.Suspicious' },
            component: () =>
                import ('@/pages/Area/Suspicious'),
        },
        {
            path: '',
            name: 'area_management',
            icon: 'fas fa-folder',
            title: 'area_management',
            meta: { perm: 'Pages.AreaManagement' }, 
            component: LayoutBlank,
            children: [{
                    path: 'command_group',
                    name: 'command_group',
                    icon: 'fas fa-list',
                    title: 'area_command_operations_group',
                    meta: { perm: 'Pages.AreaCommandOperations' }, 
                    component: () =>
                        import ('@/pages/Area/AreaManagement/CommandOperationsAreaManagement'),
                },
                {
                    path: 'distribution_point_based_report',
                    title: 'distribution_point_based_report',
                    icon: 'fas fa-clock',
                    name: 'distribution_point_based_report',
                    component: () =>
                        import ('@/pages/Area/AreaManagement/DistributionPointBasedReport'),
                    meta: { perm: 'Pages.DistributionPointBasedReport' }, 
                },
                {
                    path: 'detailed_area_entrance_exitance_report_area_route',
                    title: 'detailed_area_entrance_exitance_report_area_route',
                    icon: 'fas fa-circle-notch',
                    name: 'detailed_area_entrance_exitance_report_area_route',
                    meta: { perm: 'Report.EntryExit' }, 
                    component: () =>
                        import ('@/pages/Report/EntryExit'),
                },
            ],
        },
        // {
        //   path: 'area_management',
        //   title: 'area_route_management',
        //   icon: 'ion ion-md-settings',
        //   name: 'area_management',
        //   meta: { perm: 'Pages.Area' },
        //   component: LayoutBlank,
        //   children: [
        //     {
        //       path: 'area_list',
        //       name: 'area_list',
        //       icon: 'fas fa-list',
        //       title: 'area_list',
        //       meta: { perm: 'Pages.AreaList' },
        //       component: () => import('@/pages/Area/AreaList')
        //     },
        //     {
        //       path: 'area_create',
        //       name: 'area_create',
        //       icon: 'fas fa-vector-square',
        //       title: 'area_route_management',
        //       meta: { perm: 'Pages.AreaCreate' },
        //       component: () => import('@/pages/Area/AreaCreate')
        //     }
        //   ]
        // },
        // {
        //   path: 'route',
        //   name: 'route',
        //   icon: 'fas fa-route',
        //   title: 'route_management',
        //   meta: { perm: 'Pages.Route' },
        //   component: LayoutBlank,
        //   children: [
        //     {
        //       path: 'route_list',
        //       name: 'route_list',
        //       icon: 'fas fa-list',
        //       title: 'route_list',
        //       meta: { perm: 'Pages.Route' },
        //       component: () => import('@/pages/Area/RouteList')
        //     },
        //     {
        //       path: 'create_route',
        //       name: 'create_route',
        //       icon: 'fas fa-wave-square',
        //       title: 'route_operations',
        //       meta: { perm: 'Pages.RouteCreate' },
        //       component: () => import('@/pages/Area/RouteCreate')
        //     },
        //     {
        //       path: 'create_route_via_vehicle',
        //       name: 'create_route_via_vehicle',
        //       icon: 'ion ion-ios-car',
        //       title: 'create_route_via_vehicle',
        //       meta: { perm: 'Pages.CreateRouteViaVehicle' },
        //       component: () => import('@/pages/Area/CreateRouteviaVehicle')
        //     }
        //   ]
        // },
        // {
        //   path: 'routeCommand',
        //   name: 'route_command',
        //   icon: 'fas fa-list',
        //   title: 'area_command_operations',
        //   meta: { perm: 'Pages.RouteCommand' },
        //   component: () => import('@/pages/Area/CommandOperations')
        // }
    ],
}, ];